import icon_home from "@/assets/image/home.svg";
import icon_free from "@/assets/image/circle-free.svg";
import icon_working from "@/assets/image/circle-working.svg";
import icon_path_point from "@/assets/image/path-point.svg";
import mapStyle from "@/api/mapStyle";

const initializedZooms = 10;
export default {
  driverDdetialDialog:false,//司机详情dialog
  driver_detial_data:{},//司机详情
  markers:[],
  sidebarPosition:{},//聚合点右侧弹出框距距离
  showRightSidebar:false,//聚合点的右侧弹出框
  cluster_infoWindowWidth:'',//聚合点的偏移量
  cluster_infoWindowHight:'',
  selectedMarkers:[],
  clusterMarkers:[],//点击后聚合点的数据
  markerCluster:"",
  driverList: [],
  taskId: 0,
  infoWindowWidth:'',
  driver_info_width:"",
  currentTask: [],//用来控制高亮
  mult_select_list:[],//多选拖动div
  unassigned_drag:true,//未分配任务是否可拖拽
  newTask: [],
  dropTreeTask: {},
  dropLeaveTreeTask: {},
  detialDialog:false,
  deleteDialog:false,
  taskMenu: {
    x: 0,
    y: 0,
    task: null,
    taskType: ''
  },
  click_task:{},


  initial_data:[],
  fn: null,
  timer: null,
  driver_list:[],
  isFullScreen: false,
  task_type:'',
  deleteTitle:'Delete task',//弹框title
  task_invoice_number:"",
  task_delete_type:0,
  delete_data:'',
  info: "",
  top: 0,
  left: 0,
  path: [],//用来画线的数组
  highlight: true,//控制droptree 高亮
  inSourceLists: [],
  activeTitlfe: 1,//用来控制 assignlist
  inTabList: [],//右边树司机任务对应的tabs
  shList: [],//右边树 初始 s-h 的数组
  node_had: [], // 触发 tree 的 :load=loadNode 重复触发  动态更新tree
  resolve_had: [], // 触发 tree 的 :load=loadNode 重复触发  动态更新tree
  infoWindow: {
    position: {lat: 0, lng: 0}, open: false, template: ''
  },
  //所有的图标
  icons: {icon_home, icon_free, icon_working, icon_path_point},
  unassignedList: [],
  sourceLists: [],
  activeName: 'S-H',
  activeName1: 'S-H',
  tabLists: [],
  defaultProps: {
    children: 'childen_data',
    label: 'name',
    id: 'id',
  },
  centers: {
    lat: 43.6730982190642,
    lng: -79.41431566926937
  },
  initializedZooms,
  mapOptionss: {
    backgroundColor: '#292d31',
    zoomControl: false,//关闭缩放控制
    mapTypeControl: false,//关闭地图类型选择
    scaleControl: true,//
    streetViewControl: false,//关闭街景
    rotateControl: false,//关闭旋转控制
    fullscreenControl: false,//关闭全屏控制
    styles: mapStyle,
    disableDoubleClickZoom: true,
    clickableIcons: false
  },

  placeholderColor: '#CCCCCC'
}
